import { createConfig } from '@privy-io/wagmi'
import { chain } from './chain'
import { buildTransport } from './transport'

// RPC URL の唯一のソースは `chain.ts` の `withCustomRpc` 適用後の chain オブジェクト。
// ここでは `chain.rpcUrls.default.http` から URL を取り出して transport を構築するだけで、
// env 変数の直接参照はしない(env 読み出しは chain.ts に集約)。
const [primaryUrl, fallbackUrl] = chain.rpcUrls.default.http

export const wagmiConfig = createConfig({
  chains: [chain],
  transports: {
    [chain.id]: buildTransport(primaryUrl, fallbackUrl),
  },
})
